<template>
  <div class="Login">
    <b-container>
      <a class="float-sm-left" href="https://github.com/CHIMEFRB/frb-web/blob/master/src/components/login.vue" target="_blank" style="color:black">
        <b-icon icon="github" aria-hidden="true" font-scale="1.0"></b-icon>
      </a>
      <div class="text-center">
        <h1>Welcome to CHIME/FRB</h1>
        <p>Please log in using your LDAP account (same as Grafana/Liberty/Tubular)</p>
      </div>
      <b-form @submit.prevent="onSubmit">
        <b-form-group>
          <b-form-input v-model="username" type="text" placeholder="Username" required/>
        </b-form-group>

        <b-form-group :invalid-feedback="invalidFeedback">
          <b-form-input v-model="password" type="password" placeholder="Password" required/>
        </b-form-group>

        <div class="text-center">
          <b-button type="submit" variant="primary" block>Sign In</b-button>
        </div>
      </b-form>
      <div class="text-center">
        <span id="loginStatus"></span>
      </div>
    </b-container>
  </div>
</template>

<script>
import { AuthVerificationMixin } from './mixins/auth_mixin.js'
import { bus } from '../main'
import Cookie from 'js-cookie'
var baseUrl = 'https://frb.chimenet.ca/frb-master/'
export default {
  mixins: [AuthVerificationMixin],
  data () {
    return {
      baseUrl: baseUrl,
      username: '',
      password: '',
      invalidFeedback: ''
    }
  },
  updated () {
    this.reloadWindow()
    this.checkCurrentLogin()
  },
  methods: {
    onSubmit (evt) {
      document.getElementById('loginStatus').innerHTML = ''
      var url = this.baseUrl + 'auth/passive'
      // url = 'http://localhost:8001/auth/passive'
      var userCredentials = {'username': this.username, 'password': this.password}
      this.$http.post(url, userCredentials)
        .then(user => {
          Cookie.remove('access_token')
          localStorage.accessToken = user.body.access_token
          localStorage.refreshToken = user.body.refresh_token
          localStorage.accessTime = Date.now() / 1000
          localStorage.username = this.username
          localStorage.isLogged = true
          bus.$emit('logged', 'User logged')
          this.$router.replace(this.$route.query.redirect || '/frb-web')
          // store username and token in localstorage.
        }, user => {
          this.invalidFeedback = 'Incorrect username or password'
          document.getElementById('loginStatus').style.color = 'red'
          document.getElementById('loginStatus').innerHTML = this.invalidFeedback
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue